import { createAsyncThunk } from "@reduxjs/toolkit";

import { ajax } from "../../../utils/ajax";
import { ICustomerSummary } from "../models";

/**
 * Loads the customer currently being assisted by this CSR agent.
 *
 * This is called when the CSR toolbar initializes to display which customer
 * (if any) is currently being assisted. The CSR session maintains this state
 * on the backend, so this endpoint returns the active customer or null.
 *
 * @returns Promise resolving to the currently assisted customer or null
 */
export const loadCurrentlyAssistedCustomer = createAsyncThunk(
    "csr/loadCurrentlyAssistedCustomer",
    async (): Promise<ICustomerSummary> => {
        const resp = await ajax
            .get("/api/csr/users/currently_assisted_user/")
            .set("Accept", "application/json");
        return resp.body as ICustomerSummary;
    },
);
